import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

export const secondsToMinutes = (seconds: number) => Math.floor(seconds / 60);

export const displayWaitTimes = (anticipatedWait: number) => {
    return anticipatedWait > 0;
}

export interface IUseWaitTimes {
    displayWaitTimes: boolean;
    anticipatedWaitTimeSeconds: number | null;
    waitingRange: string;
    waitingLabel: string;
}

const waitingText = (minutes: number): { waitingLabel: string, waitingRange: string } => {
    if (minutes < 5) {
        return { waitingRange: "5", waitingLabel: "up to" };
    } else if (minutes < 10) {
        return { waitingRange: "5 - 10", waitingLabel: "between" };
    } else if (minutes < 15) {
        return { waitingRange: "10 - 15", waitingLabel: "between" };
    } else if (minutes < 20) {
        return { waitingRange: "15 - 20", waitingLabel: "between" };
    }

    return { waitingRange: "20", waitingLabel: "over" };
}

export const useWaitTimes = (): IUseWaitTimes => {
    let anticipatedWaitTimeSeconds = 0;
    const selectedStore = useSelector((state: ApplicationState) => state.location?.selectedStore);
    if(selectedStore)
        anticipatedWaitTimeSeconds = selectedStore.waitTimeModel.anticipatedWaitTimeSeconds ?? 0;
    
    const minutes = secondsToMinutes(anticipatedWaitTimeSeconds);

    return {
        displayWaitTimes: displayWaitTimes(minutes),
        ...waitingText(minutes),
        anticipatedWaitTimeSeconds,
    }
}
